import React, { useRef } from "react";
import InstantCheckImg from "../../assets/icons/InstantCheck.png";
import BackgroundCheckImg from "../../assets/icons/BackgroundCheck.png";
import DueDiligenceImg from "../../assets/icons/DueDiligence.png";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SolutionCard, SolutionCardButtonWrapper, SolutionCardDescription, SolutionCardDescriptionWrapper, SolutionCardImageWrapper, SolutionCardSubtitle, SolutionCardTitle, SolutionsCardsContainer, SolutionsContainer, SolutionsSubtitle, SolutionsTitle } from "../../assets/styles/HomeStyles";


const solutionsData = [
  {
    title: "Instant Checks",
    subtitle: "Simplify Processes.<br /> Save Time. Minimize Risk.",
    image: InstantCheckImg,
    description:
      "<b>Say goodbye to long wait times and complicated processes.</b> With our one-click instant checks, you can quickly verify employees, customers, and third parties. Streamline your onboarding process, ensure compliance, and stay ahead of potential risks by being safe - all in real time. Our 100% DIY model puts you in control.",
    path: "/instant-checks",  
  },
  {
    title: "Background Checks",
    subtitle: "Go Beyond the Basics.<br /> Build Stronger Foundations.",
    image: BackgroundCheckImg,
    description:"<b>Safety is built on Trust and Trust is built on certainty.</b> Our customized background verification services dive deep to ensure you have accurate information on employees, clients, or external partners. By validating every critical detail, you can make smarter, more secure decisions for your business. Because when it comes to trust and safety, the details matter.",
    path: "/background-checks",
  },
  {
    title: "Due Diligence",
    subtitle: "Empower Your Decisions <br /> with Confidence.",
    image: DueDiligenceImg,
   description:"<b>Make every decision count with our meticulous due diligence services.</b> We provide in-depth insights into your dealers, customers, and partners—helping you evaluate risks, build visibility, and create transparent partnerships. With iScreening, every decision is backed by clarity and precision, giving you a safe foundation to move forward with confidence.",
    path: "/due-diligence",
  },
];

const Solutions = ({ solutionsRef }) => {
  const descRefs = useRef([]);
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <div ref={solutionsRef} id="solutions">
      <SolutionsContainer >
        <SolutionsTitle >Solutions for every business</SolutionsTitle>
        <SolutionsSubtitle >
          Business challenges are inevitable, but navigating them doesn’t have to be overwhelming. At iScreening, we’re here to simplify the complex. From instant checks to comprehensive background verification and due diligence, our solutions turn scattered data into actionable insights—giving you clarity, confidence, and control to dive as deep as you need.
        </SolutionsSubtitle>
        <SolutionsCardsContainer >
          {solutionsData.map((solution, index) => (
            <SolutionCard key={index} >
              <SolutionCardImageWrapper
                src={solution.image}
                alt={solution.title}
              />
              <SolutionCardTitle >{solution.title}</SolutionCardTitle>
              <SolutionCardSubtitle
                dangerouslySetInnerHTML={{ __html: solution.subtitle }} 
              />
              <SolutionCardDescriptionWrapper
                ref={(el) => (descRefs.current[index] = el)}
                style={{
                  height: "8vw",
                }}
              >
                <SolutionCardDescription
                  dangerouslySetInnerHTML={{ __html: solution.description }} 
                />
              </SolutionCardDescriptionWrapper>

              <SolutionCardButtonWrapper>
                <Button
                  className="custom-button small-padding"
                  variant="contained"
                  onClick={() => handleNavigate(solution.path)}
                >
                  Know More
                </Button>
              </SolutionCardButtonWrapper>
            </SolutionCard>
          ))}
        </SolutionsCardsContainer>
      </SolutionsContainer>
    </div>
  );
};

export default Solutions;
